import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import { SettingsCache } from '~/lib/consts/settings-cache';
import SmartSendBookedItems from '../my-orders/booked-items';
import InTransit from '../my-orders/orders-intransit';
import SmartSendSoldItems from '../smartsend/sold-items';
import ArchivedOrders from '../my-orders/archived-orders';

export const childrenOfOrders = [
  {
    path: RoutingConstants.SmartSend,
    element: <SmartSendSoldItems />
  },
  {
    path: RoutingConstants.OrderHistory,
    element: <SmartSendBookedItems />
  },
  {
    path: RoutingConstants.InTransit,
    element: <InTransit />
  },
  {
    path: RoutingConstants.ArchivedOrders,
    element: <ArchivedOrders />
  }
];

export const routesOfOrders = childrenOfOrders.map((r) => r.path);

export const sanitisedRoutesOfOrders = () =>
  routesOfOrders.filter((r) => {
    switch (r) {
      case RoutingConstants.ArchivedOrders:
        return SettingsCache.settings.Features.includes('ArchivedOrders');

      default:
        return true;
    }
  });
